const viewPortSizeMappingHorizontal = {
  mobile: [320, 50],
  tablet: [728, 90],
  desktop: [728, 90]
};

const viewPortSizeMappingVertical = {
  mobile: [300, 250],
  tablet: [300, 600],
  desktop: [300, 600]
};

const viewPortSizeMappingSquare = {
  mobile: [300, 250],
  tablet: [300, 250],
  desktop: [300, 250]
};

export const sizes = {
  "Horizontal-Ad": viewPortSizeMappingHorizontal,
  Mrec: viewPortSizeMappingSquare,
  "Vertical-Ad": viewPortSizeMappingVertical,
  "Story-Mrec": viewPortSizeMappingSquare,
  "Story-Middle-Ad": viewPortSizeMappingHorizontal,
  "Story-Bottom-Ad": viewPortSizeMappingHorizontal
};
